import React, { useReducer } from "react";
import DestinationContext from "./destinationContext";
import destinationReducer from "./destinationReducer";
import { API_BASE, apiErrorMessage, authedFetch } from "../../utils/api";

import {
    ADD_DESTINATION,
    ADD_DESTINATION_COMPLETE,
    ADD_DESTINATION_ERROR,
    GET_DESTINATIONS,
    GET_DESTINATIONS_ERROR,
    UPDATE_DESTINATION,
    UPDATE_DESTINATION_ERROR,
    DELETE_DESTINATION,
    DELETE_DESTINATION_ERROR,
} from "../types";


const DestinationState = (props) => {
    const initialState = {
      destinations: [],
      loading: true,
      destinationAdded: false,
      message: null,
    };
  
    const [state, dispatch] = useReducer(destinationReducer, initialState);
  
    const getDestinations = async () => {
      var url = `${API_BASE}/destinations`;
  
      const res = await authedFetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const res_json = await res.json();
      console.log(res_json);
      if (res.ok) {
        dispatch({ type: GET_DESTINATIONS, payload: res_json });
      } else {
        var error_msg = null;
        if (res.status === 401) {
          error_msg = "Unauthorized";
        } else {
          error_msg = apiErrorMessage(res_json);
        }
        dispatch({ type: GET_DESTINATIONS_ERROR, payload: error_msg });
      }
    }
  
    const addDestination = async (destination) => {
      console.log(destination);
      const formData = new FormData();
      formData.append("name", destination.name);
      formData.append("description", destination.description);
      formData.append("placeId", destination.placeId);
      if (destination.cover_photos !== undefined && destination.cover_photos !== null) {
        // hardcode to have only 1
        formData.append("photoNum", 1);
        formData.append("photo-0", destination.cover_photos);
      } else {
        formData.append("photoNum", 0);
      }
      
      formData.append("placeId", destination.placeId);
      const res = await authedFetch(`${API_BASE}/destination`, {
        method: "POST",
        body: formData,
      });
      const res_json = await res.json();
      if (res.ok) {
        dispatch({ type: ADD_DESTINATION, payload: res_json });
      } else {
        dispatch({ type: ADD_DESTINATION_ERROR, payload: apiErrorMessage(res_json) });
      }
    };
  
    const addDestinationComplete = () => {
      dispatch({ type: ADD_DESTINATION_COMPLETE });
    };

    const updateDestination = async (id, fields) => {
      const formData = new FormData();
      if (fields.name != null) formData.append("name", fields.name);
      if (fields.description != null) formData.append("description", fields.description);
      if (fields.cover_photo) formData.append("cover_photo", fields.cover_photo);

      const res = await authedFetch(`${API_BASE}/destination/${id}`, {
        method: "PUT",
        body: formData,
      });
      const res_json = await res.json();
      if (res.ok) {
        dispatch({ type: UPDATE_DESTINATION, payload: res_json });
        return { ok: true, data: res_json };
      } else {
        dispatch({ type: UPDATE_DESTINATION_ERROR, payload: apiErrorMessage(res_json) });
        return { ok: false, msg: apiErrorMessage(res_json) };
      }
    };

    const deleteDestination = async (id) => {
      const res = await authedFetch(`${API_BASE}/destination/${id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        dispatch({ type: DELETE_DESTINATION, payload: id });
        return { ok: true };
      }
      let error_msg = "Failed to delete destination";
      try {
        const res_json = await res.json();
        error_msg = apiErrorMessage(res_json) || error_msg;
      } catch (e) {}
      dispatch({ type: DELETE_DESTINATION_ERROR, payload: error_msg });
      return { ok: false, msg: error_msg };
    };

    return (
      <DestinationContext.Provider
        value={{
          destinations: state.destinations,
          loading: state.loading,
          destinationAdded: state.destinationAdded,
          message: state.message,
          getDestinations,
          addDestination,
          addDestinationComplete,
          updateDestination,
          deleteDestination,
        }}
      >
        {props.children}
      </DestinationContext.Provider>
    );
  };
  
  export default DestinationState;
  